// extracted by mini-css-extract-plugin
module.exports = {"grid":"_113lI","heroItemContainer":"_2AyIx","heroItem":"_1x24P","result":"_3JL9L"};